module.exports = __webpack_public_path__ + "5749bd41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/index_hero/gogobusiness/gogovan_logo@2x.png
// module id = 1172
// module chunks = 0